import { useEffect } from "react";
import BreadCrumbs from "../common/BreadCrumbs";
import ServiceGrid from "../components/services/ServiceGrid";

const Services = ({
  setTab,
}: {
  setTab: React.Dispatch<React.SetStateAction<string>>;
}) => {
  useEffect(() => {
    setTab("services");
  }, [setTab]);
  return (
    <>
      <BreadCrumbs
        title="Services"
        description="Discover what we offer to help you grow."
      />
      <div className="home4-services-section two sec-mar">
        <div className="container-xl container-fluid">
          <ServiceGrid />
        </div>
      </div>
    </>
  );
};

export default Services;
